<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row style="border:0px solid green;position: inherit;display:contents;width:100%;">
        <div
          class="box box-info"
          v-show="true"
          style="border-top: 30px solid #d2d6de;border-top-color: #00c0ef !important;background-color:#f9f9f9;"
        >
          <div
            class="box-header with-border"
            v-show="true"
            style="text-align:center; font-size: 14px;text-align:left;color:#5b6c7f;
            border:0px solid red;background-color:transparent;color:white;display: -webkit-box;margin-top: -40px;"
          >
            <h3 class="box-title" style="position: absolute;margin-top:5px">Quản Lý Dọn Phòng</h3>

            <h3 class="box-title" style="position: absolute;margin-top:5px; float:right;right:0">
              <lte-button
                v-show="isShowRC"
                style="float:right; display:absolute;float:right;right:0;font-size: 14px;margin-right: 10px;padding:0px;background:transparent;"
                type="btn"
                right_icon="fa fa-minus"
                @click="onMinus"
              ></lte-button>
              <lte-button
                v-show="!isShowRC"
                style="float:right; display:absolute;float:right;right:0;font-size: 14px;margin-right: 10px;padding:0px;background:transparent;"
                type="btn"
                right_icon="fa fa-plus"
                @click="onPlus"
              ></lte-button>
            </h3>
          </div>

          <div
            v-show="isShowRC"
            class="box-body"
            style="border:1px solid #00c0ef;margin-top: 20px;"
          >
            <div class="row" style="margin-bottom: 10px;margin-left:15px;">
              <!-- Start Time -->
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <label>Chọn Ngày</label>
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                    <date-picker
                      class="form-control"
                      placeholder="Từ Ngày"
                      :value="apartment_cleaning_service.start_time"
                      v-model="apartment_cleaning_service.start_time"
                      :config="options"
                    ></date-picker>
                  </div>
                </div>
              </div>
              <!-- End Time -->
              <div v-show="false" class="col-sm-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Đến Ngày</label>
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                    <date-picker
                      class="form-control"
                      placeholder="Đến Ngày"
                      :value="apartment_cleaning_service.end_time"
                      v-model="apartment_cleaning_service.end_time"
                      :config="options"
                    ></date-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div
                class="col-sm-3 col-md-3 col-lg-3"
                style="margin-top:-20px;margin-bottom:10px;margin-left:30px;"
              >
                <button
                  type="button"
                  class="btn btn-labeled btn-info pull-left"
                  @click="onSearchCleaningService"
                >
                  <span class="btn-label">
                    <i class="fa fa-money"></i>
                  </span>
                  Tìm Kiếm
                </button>
              </div>
            </div>
            <!-- Color Explaination -->
            <div class="row" style="margin-bottom:30px;">
              <div style="float:left">
                <div
                  style="float:left;background-color:chocolate;width:20px;height;20px;border-radius:4px;margin-left:45px;"
                >&nbsp;</div>
                <div style="float:left">
                  <span>&nbsp;Dọn Phòng Có Người</span>
                </div>
              </div>

              <div style="float:left">
                <div
                  style="float:left;background-color:cornflowerblue;width:20px;height;20px;border-radius:4px;margin-left:45px;"
                >&nbsp;</div>
                <div style="float:left">
                  <span>&nbsp;Dọn Phòng Trống</span>
                </div>
              </div>

              <div style="float:left">
                <div
                  style="float:left;background-color:#00c0ef;width:20px;height;20px;border-radius:4px;margin-left:45px;"
                >&nbsp;</div>
                <div style="float:left">
                  <span>&nbsp;Đã Dọn</span>
                </div>
              </div>

              <div style="float:left">
                <div
                  style="float:left;background-color:darkslategrey;width:20px;height;20px;border-radius:4px;margin-left:45px;"
                >&nbsp;</div>
                <div style="float:left">
                  <span>&nbsp;Kiểm Kê Checkin</span>
                </div>
              </div>

              <div style="float:left">
                <div
                  style="float:left;background-color:steelblue;width:20px;height;20px;border-radius:4px;margin-left:45px;"
                >&nbsp;</div>
                <div style="float:left">
                  <span>&nbsp;Kiểm Kê Checkout</span>
                </div>
              </div>

              <div style="float:left">
                <div
                  style="float:left;background-color:olive;width:20px;height;20px;border-radius:4px;margin-left:45px;"
                >&nbsp;</div>
                <div style="float:left">
                  <span>&nbsp;Đã Kiểm Kê</span>
                </div>
              </div>
            </div>
            <!--  -->
            <div class="row">
              <div
                style="text-align:center; color: red;"
                v-show="gridCleaningServiceDataList.length <= 0"
              >{{$t('apartmentbookings.noresultsfound')}}</div>
              <div
                style="margin-left:30px;display:center;"
                v-for="item in gridCleaningServiceDataList"
                :key="item.id"
              >
                <div>
                  <div
                    style="margin-top: auto;margin-bottom: auto;text-align:center;color:black"
                    class="col-sm-2 col-md-2"
                    v-if="item.is_clean != ''"
                    @click="openModal('modal-cleaing-service-modal',item.apartment_id, item.cleaning_service_id)"
                  >
                    <!-- <p v-if="item.status == 1" class="btn-change-apartment-type-selected1">
                      <b>
                        <h2>{{item.is_clean}}</h2>
                        <h4>{{item.apartment_code}}</h4>
                      </b>
                    </p>
                    <p v-else-if="item.status == 2" class="btn-change-apartment-type-selected2">
                      <b>
                        <h2>{{item.is_clean}}</h2>
                        <h4>{{item.apartment_code}}</h4>
                      </b>
                    </p>
                    <p v-else-if="item.status == 3" class="btn-change-apartment-type-selected3">
                      <b>
                        <h2>{{item.is_clean}}</h2>
                        <h4>{{item.apartment_code}}</h4>
                      </b>
                    </p>
                    <p v-else-if="item.status == 4" class="btn-change-apartment-type-selected4">
                      <b>
                        <h2>{{item.is_clean}}</h2>
                        <h4>{{item.apartment_code}}</h4>
                      </b>
                    </p>
                    <p v-else-if="item.status == 5" class="btn-change-apartment-type-selected5">
                      <b>
                        <h2>{{item.is_clean}}</h2>
                        <h4>{{item.apartment_code}}</h4>
                      </b>
                    </p>
                    <p v-else class="btn-change-apartment-type-selected6">
                      <b>
                        <h2>{{item.is_clean}}</h2>
                        <h4>{{item.apartment_code}}</h4>
                      </b>
                    </p>-->
                    <p v-if="item[item.id].status == 1" :class="item[item.id].fg_color">
                      <b>
                        <h2>{{item.is_clean}}</h2>
                        <h4>{{item.apartment_code}}</h4>
                      </b>
                    </p>
                    <p v-else-if="item[item.id].status == 2" :class="item[item.id].fg_color">
                      <b>
                        <h2>{{item.is_clean}}</h2>
                        <h4>{{item.apartment_code}}</h4>
                      </b>
                    </p>
                    <p v-else-if="item[item.id].status == 3" :class="item[item.id].fg_color">
                      <b>
                        <h2>{{item.is_clean}}</h2>
                        <h4>{{item.apartment_code}}</h4>
                      </b>
                    </p>
                    <p v-else-if="item[item.id].status == 4" :class="item[item.id].fg_color">
                      <b>
                        <h2>{{item.is_clean}}</h2>
                        <h4>{{item.apartment_code}}</h4>
                      </b>
                    </p>
                    <p v-else-if="item[item.id].status == 5" :class="item[item.id].fg_color">
                      <b>
                        <h2>{{item.is_clean}}</h2>
                        <h4>{{item.apartment_code}}</h4>
                      </b>
                    </p>
                    <p v-else-if="item[item.id].status == 6" :class="item[item.id].fg_color">
                      <b>
                        <h2>{{item.is_clean}}</h2>
                        <h4>{{item.apartment_code}}</h4>
                      </b>
                    </p>
                  </div>
                  <div
                    style="margin-top: auto;margin-bottom: auto;text-align:center;color:black"
                    class="col-sm-2 col-md-2"
                    v-else
                    @click="openModal('modal-cleaing-service-modal',item.apartment_id, 0)"
                  >
                    <p class="btn-change-apartment-type">
                      <b>
                        <h2>{{item.apartment_code}}</h2>
                      </b>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!--  -->
          </div>
        </div>
        <!-- <lte-modal
          v-show="isModalVisible"
          @onConfirm="onConfirm"
          @close="closeModal"
          v-for="obj in objModal"
          :key="obj.id"
          :item="obj"
        ></lte-modal>-->
        <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
        <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>
      </row>
    </div>
    <!--Modal Cleaning Service -->
    <div class="modal fade" data-backdrop="static" id="modal-cleaing-service-modal">
      <div class="modal-dialog" style="width:38% !important;">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title">Dịch Vụ Phòng</h2>
          </div>
          <div class="modal-body">
            <b-form>
              <div class="row" v-if="obj_update.id !=0">
                <leaseback-apartment-cleaning-service-modal
                  ref="LeaseBackApartmentCleaningService"
                  @closeModal="closeModal('modal-cleaing-service-modal')"
                  :item="obj_update"
                  @returnCleaningId="getCleaningId"
                ></leaseback-apartment-cleaning-service-modal>
              </div>
            </b-form>
          </div>
          <div class="modal-footer"></div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <!--Modal Cleaning Service-->
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import LTEButton from "@/components/LTEButton.vue";
// import LTEModal from "@/components/LTEModal.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
//import SelectOptionCheck from "@/components/SelectOptionCheck.vue";
//import Paginator from "@/components/Paginator.vue";
import Loading from "vue-loading-overlay";
//import i18n from "../../lang";
import utils from "@/lib/utils";
import datePicker from "vue-bootstrap-datetimepicker";
// import LeaseBackApartmentCleaningServiceModal from "./LeaseBackApartmentCleaningServiceModal";
import LeaseBackApartmentCleaningService from "./LeaseBackApartmentCleaningService";

export default {
  name: "ReceiptList",
  data() {
    return {
      management_cleaning: {},
      isShowRC: true,
      buttonName: "danger",
      labelName: "Name",
      gridCleaningServiceDataList: [],
      isLoading: false,
      rowCleaningService: [],
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false,
        // minDate: new Date(Date.now() - 8640000)
        minDate: new Date(Date.now() - 8640000),
        maxDate: new Date(Date.now() + 86400000 * 30)
      },
      apartment_cleaning_service: {
        start_time: new Date(),
        end_time: new Date()
      },
      obj_update: {
        id: 0,
        checkin: null,
        checkout: null,
        cleaning_status: 0,
        cleaning_status_id: 0
      },
      gridColumns: [
        {
          key: "apartment_code",
          label: "Căn Hộ",
          sortable: true,
          class: "text-center"
        },
        {
          key: "status",
          label: "Tình Trạng",
          sortable: true,
          class: "text-center"
        }
      ],
      gridLiablityColumns: [
        {
          key: "amount_in_wallet",
          label: "Số Tiền",
          sortable: true,
          class: "text-center",
          thStyle: "width: 50%"
        },
        {
          key: "amount_liability",
          label: "Số Thu",
          sortable: true,
          class: "text-center",
          thStyle: "width: 50%"
        }
      ]
    };
  },
  watch: {
    GET_APARTMENT_CLEANING_SERVICE_DATA: function() {
      this.gridCleaningServiceDataList = [];
      //let cleaning_service_data_list = [];
      this.isPaid = [];
      this.GET_APARTMENT_CLEANING_SERVICE_DATA.forEach(
        (cleaning_service, i) => {
          // Build Data
          let data = {};
          let apartment_id = cleaning_service["apartment_id"];
          let apartment_code = cleaning_service["apartment_code"];
          data["apartment_code"] = apartment_code;
          data["apartment_id"] = apartment_id;
          data["id"] = apartment_id;
          data["cleaning_service_id"] = cleaning_service["cleaning_service_id"];
          data["status"] = cleaning_service["status"];
          data["is_clean"] =
            cleaning_service["cleaning_service"]["hour"] > 0
              ? this.formatHour(cleaning_service["cleaning_service"]["hour"]) +
                ":" +
                this.formatHour(cleaning_service["cleaning_service"]["minute"])
              : "";
          this.management_cleaning[apartment_id] = {
            cleaning_service_id: cleaning_service["cleaning_service_id"],
            status: cleaning_service["status"],
            fg_color: this.getColor(cleaning_service["status"])
          };
          data[apartment_id] = {
            cleaning_service_id: cleaning_service["cleaning_service_id"],
            status: cleaning_service["status"],
            fg_color: this.getColor(cleaning_service["status"])
          };
          this.gridCleaningServiceDataList.push(data);
        }
      );
    },
    GET_APARTMENT_CLEANING_SERVICE_START_END_TIME_DATA: function() {
      this.gridCleaningServiceDataList = [];
      //let cleaning_service_data_list = [];
      this.isPaid = [];
      this.GET_APARTMENT_CLEANING_SERVICE_DATA.forEach(
        (cleaning_service, i) => {
          let apartment_id = cleaning_service["apartment_id"];
          if (i == 0) {
            //console.log(cleaning_service[apartment_id]);
            // Build Header
            let header_hidden_index = {
              key: "index",
              label: "",
              sortable: false,
              class: "text-center",
              thStyle: {
                display: "none"
              }
            };
            let header = {
              key: "apartment_code",
              label: "Căn Hộ",
              sortable: true,
              class: "text-center"
            };
            this.gridColumns.push(header);

            for (const [key] of Object.entries(
              cleaning_service[apartment_id]
            )) {
              //console.log(key, value);
              header = {
                //key: apartment_id + "_" + key,
                key: key,
                label: key,
                sortable: true,
                class: "text-center"
              };
              this.gridColumns.push(header);
            }
            this.gridColumns.push(header_hidden_index);
          }

          // Build Data
          //apartment_id = cleaning_service["apartment_id"];
          let data = {};
          let apartment_code = cleaning_service["apartment_code"];
          data["apartment_code"] = apartment_code;
          data["id"] = cleaning_service["apartment_id"];
          let index = 0;
          for (const [key, value] of Object.entries(
            cleaning_service[apartment_id]
          )) {
            index += 1;
            let _key = apartment_id + "_" + key;
            this.rowCleaningService[_key] =
              value["hour"] > 0
                ? this.formatHour(value["hour"]) +
                  ":" +
                  this.formatHour(value["minute"])
                : "";
            let row_cleaning_service =
              "rowCleaningService[" + apartment_id + "_" + key + "]";
            data[[row_cleaning_service]] = this.rowCleaningService[_key];
            data[key] =
              value["hour"] > 0
                ? this.formatHour(value["hour"]) +
                  ":" +
                  this.formatHour(value["minute"])
                : "";
            data["index"] = "";
            data["_index"] = index;
            // if (value["hour"] != "" || value["hour"] != null) {
            //   let _key = apartment_id + "_" + key;
            //   this.rowCleaningService[_key] = value["hour"];
            //   let row_cleaning_service =
            //     "rowCleaningService[" + apartment_id + "_" + key + "]";
            //   data[[row_cleaning_service]] = this.rowCleaningService[
            //     apartment_id
            //   ];
            // } else {
            //   this.rowCleaningService[apartment_id] = value["hour"];
            //   let row_cleaning_service =
            //     "rowCleaningService[" + apartment_id + "]";
            //   data[[row_cleaning_service]] = this.rowCleaningService[
            //     apartment_id
            //   ];
            // }
            // console.log(key);
            // console.log(value["hour"]);
          }
          this.gridCleaningServiceDataList.push(data);
          // console.log(cleaning_service);
          // console.log(i);
        }
      );
      //console.log(this.gridCleaningServiceDataList);
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_APARTMENT_CLEANING_SERVICE_DATA",
      "GET_APARTMENT_CLEANING_SERVICE_START_END_TIME_DATA"
    ])
  },
  methods: {
    getColor: function(status) {
      if (status == 1) {
        return "btn-change-apartment-type-selected1";
      } else if (status == 2) {
        return "btn-change-apartment-type-selected2";
      } else if (status == 3) {
        return "btn-change-apartment-type-selected3";
      } else if (status == 4) {
        return "btn-change-apartment-type-selected4";
      } else if (status == 5) {
        return "btn-change-apartment-type-selected5";
      } else {
        return "btn-change-apartment-type-selected6";
      }
    },
    formatHour: function(hour) {
      if (hour < 10) {
        return "0" + hour;
      }
      return hour;
    },
    onMinus: function() {
      this.isShowRC = false;
    },
    onPlus: function() {
      this.isShowRC = true;
    },
    openModal: function(id_modal, apartment_id, cleaning_service_id) {
      this.obj_update.cleaning_status_id = cleaning_service_id;
      this.obj_update.id = apartment_id;
      $("#" + id_modal).modal("show");
    },
    closeModal: function(id_modal) {
      this.obj_update.id = 0;
      this.obj_update.cleaning_status_id = 0;
      $("#" + id_modal).modal("hide");
    },
    getCleaningId: function(apartment_id, cleaning_id, status) {
      this.management_cleaning[apartment_id][
        "cleaning_service_id"
      ] = cleaning_id;
      this.management_cleaning[apartment_id]["status"] = status;
      this.management_cleaning[apartment_id]["fg_color"] = this.getColor(
        status
      );

      this.gridCleaningServiceDataList.forEach((obj, index) => {
        if (obj.id == apartment_id) {
          this.gridCleaningServiceDataList[index][
            "cleaning_service_id"
          ] = cleaning_id;
          this.gridCleaningServiceDataList[index][apartment_id][
            "cleaning_service_id"
          ] = cleaning_id;
          this.gridCleaningServiceDataList[index][apartment_id][
            "status"
          ] = status;
          this.gridCleaningServiceDataList[index][apartment_id][
            "fg_color"
          ] = this.getColor(status);
        }
      });
      this.onSearchCleaningService();
    },
    onSearchCleaningService: function() {
      this.isLoading = true;
      //this.columnsReceipt.data_list = this.gridColumns;
      // this.receipt_customer_data.receipt_created = moment().format("DD/MM/YYYY");
      const cleaning_data = {
        params: {
          start_time: utils.formatSqlDate(this.apartment_cleaning_service.start_time, this.options.format, "DD/MM/YYYY")
          // end_time: utils.formatSqlDate(this.apartment_cleaning_service.end_time, this.options.format, "DD/MM/YYYY")
        }
      };
      this.GET_APARTMENT_CLEANING_SERVICE(cleaning_data).then(
        function() {
          this.isLoading = false;
        }.bind(this)
      );
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      "GET_APARTMENT_CLEANING_SERVICE",
      // "GET_APARTMENT_CLEANING_SERVICE_START_END_TIME"
    ])
  },
  mounted() {
    this.isLoading = true;
    //this.columnsReceipt.data_list = this.gridColumns;
    // this.receipt_customer_data.receipt_created = moment().format("DD/MM/YYYY");
    const cleaning_data = {
      params: {
        start_time: utils.formatSqlDate(this.apartment_cleaning_service.start_time, this.options.format, "DD/MM/YYYY"),
        end_time:utils.formatSqlDate(this.apartment_cleaning_service.end_time, this.options.format, "DD/MM/YYYY")
      }
    };
    this.GET_APARTMENT_CLEANING_SERVICE(cleaning_data).then(
      function() {
        this.isLoading = false;
      }.bind(this)
    );
  },

  components: {
    "lte-button": LTEButton,
    // "lte-modal": LTEModal,
    "lte-core-alert": LTECoreAlert,
    loading: Loading,
    "date-picker": datePicker,
    "leaseback-apartment-cleaning-service-modal": LeaseBackApartmentCleaningService
    //"select-option-check": SelectOptionCheck
  }
};
</script>
<style lang="scss" scoped>
.btn-change-apartment-type {
  background-color: #fff;
  padding: 1px;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 2px 2px #888888;
  width: 90%;
  height: 90px;
  color: black;
}
// 1 don phong co nguoi
.btn-change-apartment-type-selected1 {
  background-color: chocolate;

  padding: 1px;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 2px 2px #888888;
  color: #fff;
  width: 90%;
  height: 90px;
}
// 2 don phong trong
.btn-change-apartment-type-selected2 {
  background-color: cornflowerblue;
  padding: 1px;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 2px 2px #888888;
  color: #fff;
  width: 90%;
  height: 90px;
}
// 3 da don
.btn-change-apartment-type-selected3 {
  background-color: #00c0ef;

  padding: 1px;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 2px 2px #888888;
  color: #fff;
  width: 90%;
  height: 90px;
}
// 4 kiem ke checkin
.btn-change-apartment-type-selected4 {
  background-color: darkslategrey;

  padding: 1px;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 2px 2px #888888;
  color: #fff;
  width: 90%;
  height: 90px;
}
// 5 kiem ke checkin
.btn-change-apartment-type-selected5 {
  background-color: steelblue;

  padding: 1px;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 2px 2px #888888;
  color: #fff;
  width: 90%;
  height: 90px;
}
// 5 kiem ke checkout
.btn-change-apartment-type-selected6 {
  background-color: olive;

  padding: 1px;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 2px 2px #888888;
  color: #fff;
  width: 90%;
  height: 90px;
}
.btn-change-apartment-type:hover {
  background-color: #e5e5e59d;
}
.icheckbox_minimal-blue {
  cursor: default !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Apartment/LeaseBackApartmentCleaningServiceManagement.vue